import type { RoofVolumeGenerationTemporaries } from "building-types/roofVolumes/roofVolumeGenerationTypes";

export function roofVolumeGenerationTemporariesNew(): RoofVolumeGenerationTemporaries {
  return {
    startBaseExtension: 0,
    endBaseExtension: 0,
    extraHipFaces: [],
  };
}
